import { useContext } from "react";
import { AllDataContext } from "../../../lib/dataContext";

import {
  FooterLink,
  Inner,
  LinkContainer,
  CitroenFooterContainer,
} from "./styles";

const CitroenFooter = () => {
  const data = useContext(AllDataContext);

  const links = data.footerItems.footerLinks;

  return (
    <CitroenFooterContainer>
      <Inner>
        <LinkContainer>
          {links?.map((link) => (
            <FooterLink
              className="p2"
              href={link.href}
              rel="noreferrer noopener"
              target="_blank"
              key={link._key}
            >
              {link.title}
            </FooterLink>
          ))}
        </LinkContainer>
      </Inner>
    </CitroenFooterContainer>
  );
};

export default CitroenFooter;
